import axios, { AxiosRequestConfig } from "axios";
import { addSagAuthInterceptor } from "@sazka/utils/http-clients/sag-auth-interceptor";
import { addSessionTokenInterceptor } from "@sazka/ng/interceptors/session-token-interceptor";
import { useSagOptions } from "@sazka/utils/http-clients/use-sag-options";
import { addPlayerIdInterceptor } from "@sazka/ng/interceptors/player-id-interceptor";

const { getSagApiUrl } = useSagOptions();

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: appSettings["Integrations:Loyalty:PlayerData:LocalDev"] ?? getSagApiUrl("ls-player-data-public"),
};

const playerDataHttpClient = axios.create(config);

/** Adding the request interceptors */
addSagAuthInterceptor(playerDataHttpClient);
addSessionTokenInterceptor(playerDataHttpClient);
addPlayerIdInterceptor(playerDataHttpClient);

export { playerDataHttpClient };
